import React, { useEffect, useMemo, useState } from "react";
import BANNER_IMAGE from '../../assets/img/budahazr.png'


const API_PRODUCTS =
    "https://ffqadir.az/backendtest_9/api/mobileLegends";

const API_SUBMIT =
    "https://ffqadir.az/backendtest_9/api/mobileCat/addinvoice";

const API_KART =
    "https://ffqadir.az/backendtest_9/api/kart";


function MobileLegends() {
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalCount, setModalCount] = useState(1);

    const [userId, setUserId] = useState("");
    const [photoFile, setPhotoFile] = useState(null);

    const [kartInfo, setKartInfo] = useState("Kart məlumatı yüklənir...");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // --------------------------------------------------
    // MƏHSULLARI YÜKLƏ
    // --------------------------------------------------
    const getProducts = async () => {
        try {
            setLoading(true);
            setError("");


            const response = await fetch(API_PRODUCTS);

            if (!response.ok) {
                throw new Error("Məhsullar yüklənmədi");
            }

            const data = await response.json();

            if (!Array.isArray(data)) {
                setProducts([]);
                return;
            }

            const sortedProducts = [...data].sort(
                (a, b) => parseFloat(a.price || 0) - parseFloat(b.price || 0)
            );

            setProducts(sortedProducts);
        } catch (err) {
            console.error("Mobile Legends products error:", err);
            setError("Məhsulları yükləyərkən xəta baş verdi.");
        } finally {
            setLoading(false);
        }


    };

    // --------------------------------------------------
    // KART MƏLUMATI
    // --------------------------------------------------
    const getKartInfo = async () => {
        try {
            const response = await fetch(API_KART);


            if (!response.ok) {
                throw new Error("Kart məlumatı alınmadı");
            }

            const data = await response.json();

            const title = data?.allKart?.[0]?.title;

            setKartInfo(title || "Kart məlumatı tapılmadı");
        } catch (err) {
            console.error("Kart info error:", err);
            setKartInfo("Kart məlumatı tapılmadı");
        }


    };

    // --------------------------------------------------
    // INITIAL
    // --------------------------------------------------
    useEffect(() => {
        getProducts();
        getKartInfo();
    }, []);

    // --------------------------------------------------
    // BODY SCROLL
    // --------------------------------------------------
    useEffect(() => {
        if (isModalOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }


        return () => {
            document.body.style.overflow = "";
        };


    }, [isModalOpen]);

    // --------------------------------------------------
    // ESCAPE
    // --------------------------------------------------
    useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === "Escape" && isModalOpen) {
                closeModal();
            }
        };


        document.addEventListener("keydown", handleEscape);

        return () => {
            document.removeEventListener("keydown", handleEscape);
        };


    }, [isModalOpen]);

    // --------------------------------------------------
    // TOTAL
    // --------------------------------------------------
    const totalPrice = useMemo(() => {
        return selectedProducts.reduce(
            (total, product) => total + Number(product.price || 0),
            0
        );
    }, [selectedProducts]);

    const finalModalTotal = useMemo(() => {
        return totalPrice * Math.max(1, Number(modalCount) || 1);
    }, [totalPrice, modalCount]);

    // --------------------------------------------------
    // SEÇİLMİŞ MƏHSUL ADLARI
    // --------------------------------------------------
    const selectedProductNames = useMemo(() => {
        return selectedProducts.map((product) => product.name).join(" + ");
    }, [selectedProducts]);

    // --------------------------------------------------
    // MƏHSUL SEÇ / ÇIXAR
    // --------------------------------------------------
    const toggleProductSelection = (item) => {
        const productId = String(item._id);


        const existingIndex = selectedProducts.findIndex(
            (product) => String(product._id) === productId
        );

        if (existingIndex !== -1) {
            setSelectedProducts((prev) =>
                prev.filter(
                    (product) => String(product._id) !== productId
                )
            );
        } else {
            setSelectedProducts((prev) => [
                ...prev,
                {
                    _id: item._id,
                    name: item.title,
                    price: parseFloat(item.price || 0),
                },
            ]);
        }


    };

    // --------------------------------------------------
    // SEÇİLİDİR?
    // --------------------------------------------------
    const isProductSelected = (item) => {
        return selectedProducts.some(
            (product) => String(product._id) === String(item._id)
        );
    };

    // --------------------------------------------------
    // MODAL AÇ
    // --------------------------------------------------
    const openMultiModal = () => {
        if (selectedProducts.length === 0) {
            alert("Zəhmət olmasa ən azı 1 paket seçin!");
            return;
        }


        setModalCount(1);
        setUserId("");
        setPhotoFile(null);
        setIsModalOpen(true);

        setTimeout(() => {
            document.getElementById("mobile-legends-user-id")?.focus();
        }, 100);


    };

    // --------------------------------------------------
    // MODAL BAĞLA
    // --------------------------------------------------
    const closeModal = () => {
        if (isSubmitting) return;


        setIsModalOpen(false);
        setModalCount(1);
        setUserId("");
        setPhotoFile(null);


    };

    // --------------------------------------------------
    // FILE SEÇ
    // --------------------------------------------------
    const handlePhotoChange = (event) => {
        const file = event.target.files?.[0] || null;
        setPhotoFile(file);
    };

    // --------------------------------------------------
    // SİFARİŞ GÖNDƏR
    // --------------------------------------------------
    const handleSubmit = async (event) => {
        event.preventDefault();


        if (isSubmitting) return;

        if (selectedProducts.length === 0) {
            alert("Zəhmət olmasa ən azı 1 paket seçin!");
            return;
        }

        if (!userId.trim()) {
            alert("Mobile LEGENDS User ID daxil edin!");
            return;
        }

        if (!photoFile) {
            alert("Zəhmət olmasa ödəniş qəbzini yükləyin!");
            return;
        }

        const count = Math.max(1, Number(modalCount) || 1);

        const formData = new FormData();

        formData.append("title", selectedProductNames);

        formData.append(
            "price",
            `${finalModalTotal.toFixed(2)} AZN`
        );

        formData.append("count", String(count));

        formData.append(
            "description",
            `${selectedProducts.length} paket seçildi`
        );

        // Backend contract saxlanılır.
        // Mobile Legends ID üçün backend "pubgId" field-i gözləyir.
        formData.append("pubgId", userId.trim());

        formData.append("photo", photoFile);

        try {
            setIsSubmitting(true);

            // YALNIZ ƏSAS API-YƏ POST GEDİR.
            // API_COPY_SUBMIT TAMAMİLƏ SİLİNİB.
            const response = await fetch(API_SUBMIT, {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Sifariş göndərilə bilmədi");
            }

            alert(
                "Sifarişiniz uğurla qəbul olundu!\n\n" +
                "⏱ Yüklənmə müddəti: 1–10 dəq.\n\n" +
                "‼️ Qeyd: Balansın görünməsi üçün oyuna yenidən daxil olun."
            );

            setIsModalOpen(false);
            setSelectedProducts([]);
            setModalCount(1);
            setUserId("");
            setPhotoFile(null);

            await getProducts();
        } catch (err) {
            console.error("Order error:", err);

            alert(
                "Xəta baş verdi. Canlı dəstək vasitəsilə əlaqə saxlayın."
            );
        } finally {
            setIsSubmitting(false);
        }


    };

    return (<div
        className="
     min-h-screen
     bg-gray-50
     dark:bg-[#040209]
     text-gray-900
     dark:text-gray-100
     overflow-x-hidden
     relative
     transition-colors
     duration-300
     selection:bg-[#FFB800]
     selection:text-black
   "
    >
        {/* =====================================================
CYBER GRID
====================================================== */}
        <div
            className="
fixed
inset-0
pointer-events-none
z-0
opacity-40
dark:opacity-100
"
            style={{
                backgroundImage: `             linear-gradient(
              to right,
              rgba(80,80,80,0.07) 1px,
              transparent 1px
            ),
            linear-gradient(
              to bottom,
              rgba(80,80,80,0.07) 1px,
              transparent 1px
            )
          `,
                backgroundSize: "40px 40px",
            }}
        />


        {/* =====================================================
      DARK MODE GLOW
  ====================================================== */}
        <div
            className="
      hidden
      md:block
      fixed
      -top-32
      -left-32
      w-[500px]
      h-[500px]
      rounded-full
      bg-purple-500/10
      dark:bg-[#8B5CF6]/20
      blur-[160px]
      pointer-events-none
      z-0
    "
        />

        <div
            className="
      hidden
      md:block
      fixed
      top-1/2
      -right-32
      w-[500px]
      h-[500px]
      rounded-full
      bg-cyan-500/10
      dark:bg-[#06B6D4]/15
      blur-[180px]
      pointer-events-none
      z-0
    "
        />

        <div
            className="
      hidden
      md:block
      fixed
      -bottom-32
      left-1/3
      w-[600px]
      h-[600px]
      rounded-full
      bg-pink-500/10
      dark:bg-[#EC4899]/15
      blur-[200px]
      pointer-events-none
      z-0
    "
        />

        {/* =====================================================
      MAIN
  ====================================================== */}
        <main
            className="
      max-w-7xl
      mx-auto
      px-3
      sm:px-5
      lg:px-8
      w-full
      py-5
      sm:py-8
      lg:py-10
      pb-28
      sm:pb-32
      space-y-6
      sm:space-y-10
      relative
      z-10
    "
        >
            {/* =================================================
        BANNER
    ================================================== */}
            <section
                className="
        w-full
        rounded-2xl
        sm:rounded-3xl
        overflow-hidden
        border
        border-gray-200
        dark:border-[#231842]
        bg-white
        dark:bg-[#0D081D]
        shadow-[0_10px_35px_rgba(0,0,0,0.08)]
        dark:shadow-[0_0_35px_rgba(139,92,246,0.25)]
      "
            >
                <img
                    src={BANNER_IMAGE}
                    alt="Mobile Legends"
                    className="
          block
          w-full
          h-auto
          max-h-[300px]
          sm:max-h-[380px]
          lg:max-h-[460px]
          object-cover
        "
                />
            </section>

            {/* =================================================
        YOUTUBE
    ================================================== */}
            <section
                className="
        max-w-4xl
        mx-auto
        rounded-2xl
        sm:rounded-3xl
        overflow-hidden
        border
        border-gray-200
        dark:border-[#231842]
        shadow-[0_10px_35px_rgba(0,0,0,0.08)]
        dark:shadow-[0_0_35px_rgba(139,92,246,0.3)]
        aspect-video
        bg-white
        dark:bg-[#0D081D]
        relative
      "
            >
                <iframe
                    className="w-full h-full"
                    src="https://www.youtube.com/embed/hGLqd3qfyQs?rel=0&modestbranding=1"
                    title="YouTube Video"
                    loading="lazy"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                />
            </section>

            {/* =================================================
        PRODUCTS SECTION
    ================================================== */}
            <section
                className="
        bg-white
        dark:bg-[#0D081D]/80
        rounded-2xl
        sm:rounded-3xl
        p-3.5
        sm:p-6
        lg:p-10
        border
        border-gray-200
        dark:border-[#231842]
        shadow-[0_10px_35px_rgba(0,0,0,0.08)]
        dark:shadow-[0_20px_50px_rgba(0,0,0,0.6)]
        space-y-5
        sm:space-y-8
        relative
        overflow-hidden
        transition-colors
      "
            >
                {/* Decorative glow */}
                <div
                    className="
          absolute
          -top-24
          -right-24
          w-72
          h-72
          bg-[#FFB800]/5
          dark:bg-[#FFB800]/10
          rounded-full
          blur-3xl
          pointer-events-none
        "
                />

               <div
                    className="
          bg-rose-50
          dark:bg-rose-950/20
          border
          border-rose-200
          dark:border-rose-500/30
          rounded-xl
          sm:rounded-2xl
          p-3
          sm:p-5
          text-[10px]
          sm:text-xs
          text-rose-700
          dark:text-rose-200/90
          flex
          items-start
          gap-2.5
          sm:gap-3.5
          relative
          z-10
        "
                >
                    <span className="text-rose-500 dark:text-rose-400 text-lg sm:text-xl shrink-0 mt-0.5">
                        ⚠
                    </span>

                    <p className="leading-relaxed">
                        3-cü şəxslərdən və ya oğurluq pullardan istifadə
                        edilərsə, Azərbaycan Respublikası qanunvericiliyinə
                        uyğun olaraq məsuliyyət daşıyırsınız. 16 yaşdan aşağı
                        şəxslərin ödəniş etməsinə icazə verilmir.
                    </p>
                </div>


                <div
                    className="
    relative
    z-10
    overflow-x-auto
    rounded-lg
    border
    border-gray-200
    dark:border-[#231842]/90
    bg-gray-50
    dark:bg-[#040209]/70
  "
                >
                    <table
                        className="
      w-full
      min-w-[340px]
      sm:min-w-[500px]
      text-left
      border-collapse
    "
                    >
                        <thead>
                            <tr className="bg-gray-100 dark:bg-[#0D081D]/90 border-b border-gray-200 dark:border-[#231842]">
                                <th
                                    className="
                      w-[42px]
                      px-2
                      py-3
                      text-center
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[62px]
                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                                >
                                    #
                                </th>

                                <th
                                     className="
                      px-2
                      py-3
                      text-left
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                                >
                                    Məhsul
                                </th>

                                <th
                                    className="
                      w-[75px]
                      px-1.5
                      py-3
                      text-right
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[120px]
                      sm:px-3.5
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                                >
                                    Qiymət
                                </th>

                                <th
                                      className="
                      w-[48px]
                      px-1
                      py-3
                      text-center
                      text-[8px]
                      font-black
                      uppercase
                      tracking-[.5px]
                      text-gray-300

                      sm:w-[68px]
                      sm:py-[15px]
                      sm:text-[11px]
                      sm:tracking-[.65px]
                    "
                                >
                                    Seç
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {/* LOADING */}
                            {loading && (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="
              px-2
              py-8
              text-center
              text-[9px]
              sm:text-xs
              text-gray-500
              dark:text-gray-400
            "
                                    >
                                        <div className="flex flex-col items-center">
                                            <svg
                                                className="
                  w-5
                  h-5
                  mb-2
                  text-[#FFB800]
                  animate-spin
                "
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="9"
                                                    stroke="currentColor"
                                                    strokeWidth="3"
                                                    opacity="0.25"
                                                />

                                                <path
                                                    d="M21 12a9 9 0 0 1-9 9"
                                                    stroke="currentColor"
                                                    strokeWidth="3"
                                                    strokeLinecap="round"
                                                />
                                            </svg>

                                            Məhsullar yüklənir...
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {/* ERROR */}
                            {!loading && error && (
                                <tr>
                                    <td
                                        colSpan="4"
                                        className="
              px-2
              py-8
              text-center
              text-[9px]
              sm:text-xs
              text-rose-500
              dark:text-rose-400
              font-bold
            "
                                    >
                                        <div className="text-2xl mb-2">
                                            ⚠
                                        </div>

                                        {error}

                                        <button
                                            type="button"
                                            onClick={getProducts}
                                            className="
                block
                mx-auto
                mt-3
                px-3
                py-1.5
                rounded-lg
                bg-[#FFB800]
                text-black
                font-black
                text-[9px]
                hover:bg-[#FF9900]
                transition
              "
                                        >
                                            Yenidən yoxla
                                        </button>
                                    </td>
                                </tr>
                            )}

                            {/* EMPTY */}
                            {!loading &&
                                !error &&
                                products.length === 0 && (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            className="
                px-2
                py-8
                text-center
                text-[9px]
                sm:text-xs
                text-gray-500
                dark:text-gray-400
                font-semibold
              "
                                        >
                                            <div className="text-2xl mb-2">
                                                📦
                                            </div>

                                            Məhsul tapılmadı.
                                        </td>
                                    </tr>
                                )}

                            {/* PRODUCTS */}
                            {!loading &&
                                !error &&
                                products.map((item, index) => {
                                    const selected = isProductSelected(item);

                                    const price = parseFloat(item.price || 0);

                                    return (
                                        <tr
                                            key={String(item._id)}
                                            onClick={() => toggleProductSelection(item)}
                                            className={`
                cursor-pointer
                border-b
                border-gray-200
                dark:border-[#231842]/65
                transition-colors
                ${selected
                                                    ? "bg-amber-50 dark:bg-[#FFB800]/[0.08] shadow-[inset_2px_0_0_#FFB800]"
                                                    : "hover:bg-amber-50/70 dark:hover:bg-[#FFB800]/[0.04]"
                                                }
              `}
                                        >
                                            {/* NUMBER */}
                                            <td
                                                 className="
        w-[42px]
        px-2
        py-2.5
        text-center

        sm:w-[62px]
        sm:px-3.5
        sm:py-3.5
      "
                                            >
                                                <span
                                                     className={`
          inline-flex
          h-[27px]
          w-[27px]
          items-center
          justify-center
          rounded-[8px]
          border
          text-[9px]
          font-black
          transition-all
          duration-200

          sm:h-[34px]
          sm:w-[34px]
          sm:rounded-[10px]
          sm:text-xs

          ${
            selected
              ? `
                border-[#FFD700]/70
                bg-gradient-to-br
                from-[#FFD700]
                to-[#FF8A00]
                text-black
                shadow-[0_0_18px_rgba(255,184,0,.35)]
              `
              : `
                border-[#FFB800]/25
                bg-[#FFB800]/[0.07]
                text-[#FFB800]
                group-hover:border-[#FFB800]/50
                group-hover:bg-[#FFB800]/[0.12]
              `
          }
        `}
                                                >
                                                    {index + 1}
                                                </span>
                                            </td>

                                            {/* PRODUCT */}
                                            <td
                                                 className="
        min-w-0
        px-2
        py-2.5

        sm:px-3.5
        sm:py-3.5
      "
                                            >
                                                <div className="min-w-0">
                                                    <div
                                                       className={`
            break-words
            text-[10px]
            font-extrabold
            leading-[1.35]
            transition-colors
            duration-200

            sm:text-sm
            sm:leading-5

            ${
              selected
                ? "text-[#FFD700]"
                : "text-white group-hover:text-[#FFD700]"
            }
          `}
                                                    >
                                                        {item.title}
                                                    </div>

                                                    <div
                                                        className="
            mt-0.5
            text-[7px]
            font-bold
            uppercase
            tracking-[.5px]
            text-gray-600

            sm:mt-1
            sm:text-[9px]
            sm:tracking-[.8px]
          "
                                                    >
                                                        Mobile LEGENDS
                                                    </div>
                                                </div>
                                            </td>

                                            {/* PRICE */}
                                            <td
                                                className="
        w-[75px]
        px-1.5
        py-2.5
        text-right

        sm:w-[120px]
        sm:px-3.5
        sm:py-3.5
      "
                                            >
                                                <span
                                                    className="
          whitespace-nowrap
          text-[10px]
          font-black
          tracking-wide
          text-[#FFB800]

          sm:text-[15px]
        "
                  
                                                >
                                                    {price.toFixed(2)} AZN
                                                </span>
                                            </td>

                                            {/* CHECK */}
                                            <td
                                              className="
        w-[48px]
        px-1
        py-2.5
        text-center

        sm:w-[68px]
        sm:px-3
        sm:py-3.5
      "
                                            >
                                                 <span
        className={`
          inline-flex
          h-[25px]
          w-[25px]
          items-center
          justify-center
          rounded-[8px]
          border
          transition-all
          duration-200

          sm:h-[30px]
          sm:w-[30px]
          sm:rounded-[9px]

          ${
            selected
              ? `
                border-[#FFD700]
                bg-gradient-to-br
                from-[#FFD700]
                to-[#FF8A00]
                shadow-[0_0_20px_rgba(255,184,0,.45)]
              `
              : `
                border-[#231842]
                bg-[#0D081D]
                group-hover:border-[#FFB800]/50
                group-hover:bg-[#171125]
              `
          }
        `}
      >
        {selected && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            className="
              h-3
              w-3
              text-black

              sm:h-4
              sm:w-4
            "
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m5 12 4 4L19 6"
            />
          </svg>
        )}
      </span>
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>

         
              

                <div
        className="
          fixed
          bottom-0
          left-0
          right-0
          z-[900]
          border-t
          border-gray-200
          bg-white/95
          px-2.5
          py-2.5
          shadow-[0_-8px_30px_rgba(0,0,0,.12)]
          backdrop-blur-xl

          dark:border-[#231842]
          dark:bg-[#080510]/95
          dark:shadow-[0_-8px_35px_rgba(0,0,0,.55)]

          sm:px-4
          sm:py-3
        "
      >
        <div
          className="
            mx-auto
            flex
            w-full
            max-w-7xl
            items-center
            gap-2
          "
        >
          {/* TOTAL */}

          <div
            className="
              flex
              min-w-0
              flex-1
              items-center
              rounded-xl
              border
              border-gray-200
              bg-gray-50
              px-3
              py-2.5

              dark:border-[#231842]
              dark:bg-[#0D081D]

              sm:px-4
              sm:py-3
            "
          >
            <div
              className="
                min-w-0
                flex-1
                overflow-hidden
              "
            >
              <div
                className="
                  text-[9px]
                  font-black
                  uppercase
                  tracking-[.35px]
                  text-gray-500

                  dark:text-gray-500

                  sm:text-[11px]
                  sm:tracking-[.7px]
                "
              >
                Seçilənlər
              </div>

              <div
                className="
                  mt-0.5
                  whitespace-nowrap
                  text-[10px]
                  font-bold
                  text-gray-700

                  dark:text-gray-300

                  sm:text-xs
                "
              >
                {selectedProducts.length} məhsul
              </div>
            </div>

            <div
              className="
                ml-2
                shrink-0
                whitespace-nowrap
                text-[13px]
                font-black
                text-amber-500

                dark:text-amber-400

                sm:ml-4
                sm:text-xl
              "
            >
              {finalModalTotal.toFixed(2)} AZN
            </div>
          </div>

          {/* ORDER */}

          <button
            type="button"
            onClick={openMultiModal}
            disabled={
              selectedProducts.length === 0
            }
            className="
              inline-flex
              min-h-[47px]
              shrink-0
              items-center
              justify-center
              gap-1.5
              rounded-xl
              border
              border-yellow-300
              bg-gradient-to-br
              from-yellow-300
              via-amber-500
              to-orange-500
              px-3
              text-[9px]
              font-black
              tracking-[.15px]
              text-[#08050b]
              shadow-[0_8px_25px_rgba(255,184,0,.22)]
              transition-all
              duration-200

              hover:-translate-y-0.5
              hover:brightness-110

              disabled:cursor-not-allowed
              disabled:border-gray-300
              disabled:bg-gray-300
              disabled:from-gray-300
              disabled:via-gray-300
              disabled:to-gray-400
              disabled:text-gray-500
              disabled:shadow-none
              disabled:hover:translate-y-0

              sm:min-h-[58px]
              sm:min-w-[260px]
              sm:gap-2.5
              sm:px-6
              sm:text-[12px]
              sm:tracking-[.5px]
            "
          >
            <span
              className="
                text-base

                sm:text-lg
              "
            >
              🛒
            </span>

            <span className="whitespace-nowrap">
              SİFARİŞİ TƏSDİQLƏ
            </span>
          </button>
        </div>
      </div>
            </section>
        </main>

        {/* =====================================================
      MODAL BACKDROP
  ====================================================== */}
        {isModalOpen && (
            <div
                className="
        fixed
        inset-0
        bg-black/70
        dark:bg-[#020108]/90
        md:backdrop-blur-md
        z-[9999999999999]
      "
                onMouseDown={(event) => {
                    if (event.target === event.currentTarget) {
                        closeModal();
                    }
                }}
            />
        )}

        {/* =====================================================
      ORDER MODAL
  ====================================================== */}
        {isModalOpen && (
            <div
                className="
        fixed
        left-1/2
        top-1/2
        -translate-x-1/2
        -translate-y-1/2
        z-[9999999999999]
        w-[calc(100vw-16px)]
        sm:w-[calc(100vw-20px)]
        max-w-[560px]
        max-h-[calc(100dvh-16px)]
        sm:max-h-[calc(100dvh-20px)]
        overflow-hidden
        flex
        flex-col
        rounded-[18px]
        sm:rounded-[28px]
        border
        border-purple-300
        dark:border-[#8B5CF6]/45
        bg-white
        dark:bg-gradient-to-br
        dark:from-[#120a25]
        dark:via-[#090612]
        dark:to-[#06040b]
        shadow-[0_30px_100px_rgba(0,0,0,0.45)]
        dark:shadow-[0_30px_100px_rgba(0,0,0,0.75),0_0_45px_rgba(139,92,246,0.2)]
      "
                role="dialog"
                aria-modal="true"
                aria-labelledby="order-modal-title"
            >
                {/* MODAL HEADER */}
                <div
                    className="
          flex
          justify-between
          items-center
          px-3.5
          sm:px-5
          py-3
          sm:py-4
          shrink-0
          dark:bg-gradient-to-r
          dark:from-[#8B5CF6]/[0.18]
          dark:via-[#FFB800]/[0.08]
          dark:to-transparent
          border-b
          border-gray-200
          dark:border-white/[0.08]
        "
                >
                    <h3
                        id="order-modal-title"
                        className="
            text-sm
            sm:text-lg
            font-black
            text-gray-900
            dark:text-white
            flex
            items-center
            gap-2
            tracking-wide
          "
                    >
                        <span className="text-[#FFB800]">
                            🧾
                        </span>

                        Sifariş Məlumatları
                    </h3>

                    <button
                        type="button"
                        onClick={closeModal}
                        disabled={isSubmitting}
                        className="
            w-8
            h-8
            sm:w-9
            sm:h-9
            rounded-full
            bg-gray-100
            dark:bg-white/5
            hover:bg-gray-200
            dark:hover:bg-white/10
            text-gray-500
            dark:text-gray-400
            hover:text-gray-900
            dark:hover:text-white
            flex
            items-center
            justify-center
            transition
            disabled:opacity-40
          "
                    >
                        ✕
                    </button>
                </div>

                {/* FORM */}
                <form
                    onSubmit={handleSubmit}
                    className="
          overflow-y-auto
          overscroll-contain
          p-3.5
          sm:p-5
          space-y-3.5
          sm:space-y-4
          text-sm
          text-gray-600
          dark:text-gray-300
        "
                >
                    {/* SELECTED PRODUCTS */}
                    <div>
                        <label
                            className="
              block
              text-[10px]
              sm:text-xs
              font-bold
              text-gray-500
              dark:text-gray-400
              uppercase
              mb-1.5
              tracking-wide
            "
                        >
                            Seçilmiş Paketlər
                        </label>

                        <input
                            type="text"
                            readOnly
                            value={selectedProductNames}
                            className="
              w-full
              min-h-[44px]
              sm:min-h-[48px]
              rounded-xl
              sm:rounded-[14px]
              bg-gray-50
              dark:bg-[#040209]/80
              border
              border-gray-200
              dark:border-white/10
              p-3
              text-gray-900
              dark:text-white
              font-semibold
              outline-none
              text-xs
              sm:text-sm
            "
                        />
                    </div>

                    {/* PACKAGE COUNT / QUANTITY */}
                    <div className="grid grid-cols-2 gap-2.5 sm:gap-3">
                        <div>
                            <label
                                className="
                block
                text-[10px]
                sm:text-xs
                font-bold
                text-gray-500
                dark:text-gray-400
                uppercase
                mb-1.5
              "
                            >
                                Paket Sayı
                            </label>

                            <input
                                type="text"
                                readOnly
                                value={`${selectedProducts.length} paket`}
                                className="
                w-full
                min-h-[44px]
                sm:min-h-[48px]
                rounded-xl
                sm:rounded-[14px]
                bg-gray-50
                dark:bg-[#040209]/80
                border
                border-gray-200
                dark:border-white/10
                p-3
                text-gray-900
                dark:text-white
                font-semibold
                outline-none
                text-xs
                sm:text-sm
              "
                            />
                        </div>

                        <div>
                            <label
                                className="
                block
                text-[10px]
                sm:text-xs
                font-bold
                text-gray-500
                dark:text-gray-400
                uppercase
                mb-1.5
              "
                            >
                                Miqdar (X)
                            </label>

                            <input
                                type="number"
                                min="1"
                                value={modalCount}
                                onChange={(event) => {
                                    const value = Math.max(
                                        1,
                                        Number(event.target.value) || 1
                                    );

                                    setModalCount(value);
                                }}
                                className="
                w-full
                min-h-[44px]
                sm:min-h-[48px]
                rounded-xl
                sm:rounded-[14px]
                bg-gray-50
                dark:bg-[#040209]/80
                border
                border-[#FFB800]/60
                p-3
                text-gray-900
                dark:text-white
                font-black
                outline-none
                focus:border-[#FFB800]
                transition
                text-sm
                sm:text-base
              "
                            />
                        </div>
                    </div>

                    {/* FINAL TOTAL */}
                    <div>
                        <label
                            className="
              block
              text-[10px]
              sm:text-xs
              font-bold
              text-gray-500
              dark:text-gray-400
              uppercase
              mb-1.5
            "
                        >
                            Yekun Qiymət
                        </label>

                        <input
                            type="text"
                            readOnly
                            value={`${finalModalTotal.toFixed(2)} AZN`}
                            className="
              w-full
              min-h-[44px]
              sm:min-h-[48px]
              rounded-xl
              sm:rounded-[14px]
              bg-gray-50
              dark:bg-[#040209]/80
              border
              border-gray-200
              dark:border-white/10
              p-3
              text-[#FFB800]
              font-black
              text-lg
              sm:text-xl
              outline-none
            "
                        />
                    </div>

                    {/* USER ID */}
                    <div className="pt-1 sm:pt-2">
                        <label
                            htmlFor="mobile-legends-user-id"
                            className="
              block
              text-[10px]
              sm:text-xs
              font-bold
              text-gray-500
              dark:text-gray-400
              uppercase
              mb-1.5
            "
                        >
                            Mobile LEGENDS User ID{" "}
                            <span className="text-rose-500">*</span>
                        </label>

                        <input
                            id="mobile-legends-user-id"
                            type="text"
                            required
                            value={userId}
                            onChange={(event) =>
                                setUserId(event.target.value)
                            }
                            placeholder="İD nömrənizi daxil edin"
                            className="
              w-full
              min-h-[44px]
              sm:min-h-[48px]
              rounded-xl
              sm:rounded-[14px]
              bg-gray-50
              dark:bg-[#040209]/80
              border
              border-gray-200
              dark:border-white/10
              p-3
              text-gray-900
              dark:text-white
              outline-none
              focus:border-[#FFB800]
              focus:ring-2
              focus:ring-[#FFB800]/10
              transition
              text-sm
              sm:text-base
            "
                        />
                    </div>

                    {/* WORK TIME */}
                    <div
                        className="
            bg-amber-50
            dark:bg-amber-500/10
            border
            border-amber-200
            dark:border-amber-500/20
            text-amber-700
            dark:text-amber-300
            p-3
            rounded-xl
            text-[10px]
            sm:text-xs
            font-semibold
            flex
            items-center
            gap-2
          "
                    >
                        <span className="text-base">
                            ⏱
                        </span>

                        İŞ SAATIMIZ: 11:00 - 04:30
                    </div>

                    {/* PAYMENT CARD */}
                    <div
                        className="
            relative
            overflow-hidden
            border
            border-[#FFB800]/25
            rounded-[15px]
            sm:rounded-[18px]
            p-3.5
            sm:p-4
            bg-gradient-to-br
            from-purple-50
            via-amber-50
            to-gray-50
            dark:from-[#8B5CF6]/[0.16]
            dark:via-[#FFB800]/[0.08]
            dark:to-[#040209]/80
          "
                    >
                        <div
                            className="
              absolute
              w-[120px]
              h-[120px]
              -right-[50px]
              -top-[55px]
              rounded-full
              bg-[#FFB800]/[0.13]
              blur-[20px]
              pointer-events-none
            "
                        />

                        <span
                            className="
              text-[9px]
              sm:text-[10px]
              text-gray-500
              dark:text-gray-400
              uppercase
              tracking-widest
              block
              font-extrabold
            "
                        >
                            Bank Ödəniş Hesabı
                        </span>

                        <p
                            className="
              relative
              z-10
              font-mono
              text-[#FFB800]
              text-sm
              sm:text-lg
              font-black
              tracking-wider
              select-all
              break-all
              mt-1
            "
                        >
                            {kartInfo}
                        </p>
                    </div>

                    {/* RECEIPT */}
                    <div>
                        <label
                            className="
              block
              text-[10px]
              sm:text-xs
              font-bold
              text-gray-500
              dark:text-gray-400
              uppercase
              mb-1.5
            "
                        >
                            Ödəniş Qəbzi (Çek)
                        </label>

                        <div
                            className="
              flex
              flex-col
              sm:flex-row
              sm:items-center
              gap-2.5
              sm:gap-3
              w-full
              p-2.5
              sm:p-3
              border
              border-dashed
              border-[#FFB800]/35
              rounded-xl
              sm:rounded-2xl
              bg-gray-50
              dark:bg-white/[0.025]
            "
                        >
                            <label
                                htmlFor="mobile-legends-upload-photo"
                                className="
                shrink-0
                bg-purple-100
                dark:bg-[#231842]/80
                hover:bg-purple-200
                dark:hover:bg-[#231842]
                border
                border-gray-200
                dark:border-white/10
                text-gray-900
                dark:text-white
                font-bold
                px-4
                py-2.5
                rounded-xl
                cursor-pointer
                transition
                text-[10px]
                sm:text-xs
                flex
                items-center
                justify-center
                gap-2
              "
                            >
                                <span className="text-[#FFB800] text-base">
                                    ↑
                                </span>

                                Qəbzi Seçin
                            </label>

                            <input
                                id="mobile-legends-upload-photo"
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={handlePhotoChange}
                            />

                            <span
                                className="
                text-[10px]
                sm:text-xs
                text-gray-500
                dark:text-gray-400
                italic
                truncate
                min-w-0
              "
                            >
                                {photoFile
                                    ? `✅ ${photoFile.name}`
                                    : "Fayl seçilməyib"}
                            </span>
                        </div>
                    </div>

                    {/* ACTIONS */}
                    <div
                        className="
            grid
            grid-cols-[1fr_1.5fr]
            gap-2
            sm:gap-2.5
            pt-3
            sm:pt-4
            mt-1
            border-t
            border-gray-200
            dark:border-[#231842]
          "
                    >
                        <button
                            type="button"
                            onClick={closeModal}
                            disabled={isSubmitting}
                            className="
              min-h-[46px]
              sm:min-h-[50px]
              rounded-xl
              sm:rounded-[14px]
              border
              border-gray-200
              dark:border-[#231842]
              text-gray-600
              dark:text-gray-300
              hover:bg-gray-100
              dark:hover:bg-white/5
              transition
              text-[10px]
              sm:text-xs
              font-bold
              disabled:opacity-40
            "
                        >
                            İmtina
                        </button>

                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="
              min-h-[46px]
              sm:min-h-[50px]
              rounded-xl
              sm:rounded-[14px]
              bg-[#FFB800]
              text-black
              font-black
              hover:bg-[#FF9900]
              transition
              text-[10px]
              sm:text-xs
              shadow-[0_0_25px_rgba(255,184,0,0.25)]
              uppercase
              disabled:opacity-60
              disabled:cursor-not-allowed
              flex
              items-center
              justify-center
              gap-2
            "
                        >
                            {isSubmitting ? (
                                <>
                                    <svg
                                        className="w-4 h-4 animate-spin"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="9"
                                            stroke="currentColor"
                                            strokeWidth="3"
                                            opacity="0.3"
                                        />

                                        <path
                                            d="M21 12a9 9 0 0 1-9 9"
                                            stroke="currentColor"
                                            strokeWidth="3"
                                            strokeLinecap="round"
                                        />
                                    </svg>

                                    GÖNDƏRİLİR...
                                </>
                            ) : (
                                "GÖNDƏR"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        )}
    </div>

    );
}

export default MobileLegends;
